import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import { PageLoading } from '@/app/components/page-loading.tsx';

const LazyRepresentativeSignUp = lazy(() => import('./RepresentativeSignUp'));

export const representativeSignUpRoute: RouteObject = {
  path: '/onboard',
  element: (
    <Suspense fallback={<PageLoading />}>
      <LazyRepresentativeSignUp />
    </Suspense>
  ),
};
